module.exports = __webpack_public_path__ + "img/kl_arjz.8a51f78c.png";